























import Vue from 'vue';

export default Vue.extend({
  name: `NewCustomButton`,
  props: {
    appendSymbol: {
      default: ``,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
    loading: {
      default: false,
      type: Boolean,
    },
  },
});
